import styled from '@emotion/styled'

import { Media, type MediaProps } from '@/components/Media'
import { BodyM } from '@/components/Typography'
import type { TitleProps } from '@/models'

import { fadeIn } from '@/styles/emotion.config'

export interface PanelItemProps
  extends Pick<MediaProps, 'layout' | 'aspectRatio' | 'width' | 'height'> {
  className?: string
  title: TitleProps
  description: string
  midia: MediaProps
}

const PanelItemStyle = styled.div({
  /* container */
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: 'var(--space-4)',
  animation: `${fadeIn} 0.3s`,
  width: '100%',
  overflow: 'hidden',

  '& .media': {
    position: 'relative',
    width: '100%',
    maxWidth: '18.375rem',
    marginBottom: '1rem',
    overflow: 'hidden',
    borderRadius: 'var(--radii-default)',
    fontSize: 0,
  },

  '& .item': {
    textAlign: 'center',
  },
})

const PanelItem = ({
  className,
  title,
  description,
  midia: medusaMidiaProps,
  width = 80,
  height = 80,
  layout = 'responsive',
  aspectRatio = 'fixed',
}: PanelItemProps) => (
  <PanelItemStyle className={className}>
    <div className="media">
      <Media
        width={width}
        height={height}
        layout={layout}
        aspectRatio={aspectRatio}
        {...medusaMidiaProps}
      />
    </div>

    <div className="item">
      <BodyM tag={title.tag || 'p'} dark="medium" emphasys>
        {title.text}
      </BodyM>

      {description && <BodyM tag="div" dark="medium" html={description} />}
    </div>
  </PanelItemStyle>
)

export default PanelItem
